import React from "react";
import { Button, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ImageCropper } from "../ImageCropper";
import { ImageCropState } from "../../hooks/useImageCrop";

type Props = {
  inputId: string;
  imageCrop: ImageCropState;
  existingImage?: string;
  error?: string;
  onRemoveExistingImage?: () => void;
};

export const ImageCropField = ({
  inputId,
  imageCrop,
  existingImage,
  error,
  onRemoveExistingImage,
}: Props) => {
  const showRemove =
    !!imageCrop.imageToUpload || (!!existingImage && !!onRemoveExistingImage);

  const handleRemove = () => {
    if (imageCrop.imageToUpload) {
      imageCrop.reset();
      return;
    }
    onRemoveExistingImage?.();
  };

  return (
    <>
      <div className="labelMainDiv">
        <label htmlFor={inputId} className="lableForImage">
          Wählen Sie eine Datei
        </label>
        {!imageCrop.imageToUpload && !existingImage && (
          <label className="labelselectfile">keine Datei ausgewählt</label>
        )}
      </div>
      <input
        type="file"
        id={inputId}
        hidden
        accept="image/*"
        onChange={imageCrop.handleImageUpload}
      />
      <div style={{ marginTop: "1.75rem" }}>
        <div className="CropContainer">
          {imageCrop.imageToUpload ? (
            <ImageCropper
              imagePreview={imageCrop.imagePreview}
              onCropComplete={imageCrop.onCropComplete}
              rotation={imageCrop.rotation}
              onRotationChange={imageCrop.setRotation}
              zoom={imageCrop.zoom}
              onZoomChange={imageCrop.setZoom}
            />
          ) : (
            existingImage && (
              <img
                alt=""
                src={existingImage}
                style={{ maxHeight: "150px", maxWidth: "270px", objectFit: "contain" }}
              />
            )
          )}
        </div>
      </div>
      {showRemove && (
        <Button
          size="small"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          onClick={handleRemove}
          sx={{ mt: 1, textTransform: "none" }}
        >
          Bild entfernen
        </Button>
      )}
      {error && (
        <Typography variant="caption" color="error" display="block">
          {error}
        </Typography>
      )}
    </>
  );
};
